"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Personnel = void 0;
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const personnelError_1 = require("./model/error/personnelError");
class Personnel {
    constructor(instance) {
        this.instance = instance;
    }
    createPersonnel(token, payload) {
        return new Promise((resolve, reject) => {
            const URL = '/personnel';
            if (!token) {
                reject(new personnelError_1.PersonnelError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const data = { ...payload };
            const config = { headers: { Authorization: `Bearer ${token}` } };
            this.instance.post(URL, data, config)
                .then((res) => {
                const personnelInfo = res.data;
                resolve(personnelInfo);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'createPersonnel'));
            });
        });
    }
    findPersonnel(token, payload) {
        return new Promise((resolve, reject) => {
            const URL = '/personnel';
            if (!token) {
                reject(new personnelError_1.PersonnelError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            let params = {};
            if (payload) {
                params = { ...payload };
            }
            const config = { headers: { Authorization: `Bearer ${token}` } };
            this.instance.get(URL, { params, ...config })
                .then((res) => {
                const personnelInfo = res.data;
                resolve(personnelInfo);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'findPersonnel'));
            });
        });
    }
    findCertificates(token, personnelID) {
        return new Promise((resolve, reject) => {
            const URL = '/personnel/certificates';
            if (!token) {
                reject(new personnelError_1.PersonnelError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const params = {
                personnel_id: personnelID,
            };
            const config = { headers: { Authorization: `Bearer ${token}` } };
            this.instance.get(URL, { params, ...config })
                .then((res) => {
                const personnelInfo = res.data;
                resolve(personnelInfo);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'findCertificates'));
            });
        });
    }
    updatePersonnelById(token, payload) {
        return new Promise((resolve, reject) => {
            const URL = `/personnel/${payload.id}`;
            delete payload.id;
            if (!token) {
                reject(new personnelError_1.PersonnelError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const data = { ...payload };
            const config = { headers: { Authorization: `Bearer ${token}` } };
            this.instance.put(URL, data, config)
                .then((res) => {
                const personnelInfo = res.data;
                resolve(personnelInfo);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'updatePersonnelById'));
            });
        });
    }
    deletePersonnelById(token, id) {
        return new Promise((resolve, reject) => {
            const URL = `/personnel/${id}`;
            if (!token) {
                reject(new personnelError_1.PersonnelError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const config = { headers: { Authorization: `Bearer ${token}` } };
            this.instance.delete(URL, config)
                .then((res) => {
                resolve(res.data);
            })
                .catch((err) => {
                reject(this.handleError_(err, 'deletePersonnelById'));
            });
        });
    }
    handleError_(error, log) {
        if (error.response.data.error !== undefined) {
            return new personnelError_1.PersonnelError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.error);
        }
        else {
            return new personnelError_1.PersonnelError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.message);
        }
    }
}
exports.Personnel = Personnel;
//# sourceMappingURL=personnel.js.map